// MarketCardSkeleton Component - Skeleton for MarketCard
import { Box, Card, CardContent, Skeleton } from '@mui/material';

export const MarketCardSkeleton = () => {
  return (
    <Card
      sx={{
        height: 260,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '18px',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          p: 1.5,
          gap: 0,
          overflow: 'hidden',
          '&:last-child': { pb: 1.5 },
        }}
      >
        {/* Header - Fixed at top */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.5 }}>
          {/* Icon */}
          <Skeleton
            variant="rounded"
            width={44}
            height={44}
            animation="wave"
            sx={{ borderRadius: '8px', flexShrink: 0 }}
          />

          {/* Title Area */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="90%" height={20} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="70%" height={16} animation="wave" />
          </Box>

          {/* Action / Chance Indicator placeholder */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
              ml: 1,
            }}
          >
            <Skeleton variant="circular" width={56} height={56} animation="wave" />
            <Skeleton variant="text" width={40} height={12} animation="wave" sx={{ mt: 0.75 }} />
          </Box>
        </Box>

        {/* Scrollable Content Area Placeholder - Variants/Buttons */}
        <Box
          sx={{
            flex: 1,
            my: 1.5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton
              variant="rounded"
              width="100%"
              height={48}
              animation="wave"
              sx={{ borderRadius: '12px', flex: 1 }}
            />
            <Skeleton
              variant="rounded"
              width="100%"
              height={48}
              animation="wave"
              sx={{ borderRadius: '12px', flex: 1 }}
            />
          </Box>
        </Box>

        <Box sx={{ p: 0, pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}></Box>

        {/* Footer Skeleton */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: 1.5,
          }}
        >
          {/* Volume */}
          <Skeleton variant="text" width={80} height={20} animation="wave" />

          {/* Bookmark */}
          <Skeleton variant="circular" width={24} height={24} animation="wave" />
        </Box>
      </CardContent>
    </Card>
  );
};

export default MarketCardSkeleton;
